import React, { useContext } from 'react'
import {DialogTitle, DialogActions, Typography } from '@mui/material'
import AddLocationIcon from '@mui/icons-material/AddLocation';
import { BootstrapDialog, Customebtn, Customeselect, CustomeFormControl } from "../StyledComponent/HintDialog1.style"
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import { useRouter } from 'next/router'
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import axios from 'axios';
import Stack from '@mui/material/Stack';
import * as config from '../../../next.config'
import TermsContext from "../../../context/Trems"
import InputLabel from '@mui/material/InputLabel'
import { useTranslation } from 'next-i18next';
import { getCookieValue, setCookiesValues } from '../../helpers/helpers';
import Map from './Map'
export default function GeoLocation(props) {
    const vocabTerms = useContext(TermsContext)
    const router = useRouter()
    const { t } = useTranslation()

    const options = {
        enableHeighAccuracy: false,

        timeout: 50000,
        maximumAge: 0
    }
    function success(pos) {
        var crd = pos.coords
        // console.log("pos=========>",pos)
        setCurrentLocation({ lat: crd.latitude, lng: crd.longitude })
        setLocationString(t("myLocation"))
        props.callBackData({lat: crd.latitude, lng: crd.longitude})
        setCookiesValues("location", JSON.stringify({ key: "my-location", lat: crd.latitude, lng: crd.longitude }))
    }
    function errors(err) {
        // console.log("err=>", err)
    }

    React.useEffect(() => {
        if (navigator.geolocation) {
            navigator.permissions.query({ name: "geolocation" }).then(res => {
                // console.log("resp---------->",res)
                // if(getCookieValue("location")==false){

                
                if (res.state == "granted") {
                    navigator.geolocation.getCurrentPosition(success, errors, options)

                }
                else if (res.state == "prompt") {

                    navigator.geolocation.getCurrentPosition(success, errors, options)

                }
                else if (res.state == "denied") {
                    navigator.geolocation.getCurrentPosition(success, errors, options)
                }
            // }
            // else{

            // }
            })
        }
        // console.log("getCookieValue==========>",getCookieValue("location"))
    }, [])
    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef(null);

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    // return focus to the button when we transitioned from !open -> open
    const prevOpen = React.useRef(open);
    React.useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }

        prevOpen.current = open;
    }, [open]);
    let limit = 50
    const [pageId, setpageId] = React.useState(1)
    const [OrderAddress, setOrderAddress] = React.useState([])
    const [isLoggedIn, setIsLoggedIn] = React.useState(false)
    const [currentLocation, setCurrentLocation] = React.useState({lng:44.191006,lat:15.369445})
    React.useEffect(() => {
        if (getCookieValue("login")) {

            setIsLoggedIn(true)
            let SearchData = {
                limit: limit,
                pageId: pageId,
                statusId: JSON.stringify((vocabTerms.statusIds))
            }
            axios.get(`${config["basePath"]}/api/orders/addresses/get`, {
                params: SearchData,
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(res => {
            //  console.log("res=========>",res)
                setOrderAddress(prevState => [...prevState, ...res.data.data.data]);
                if (getCookieValue("location")) {
                    let locationObj = getCookieValue("location")
                 
                    if (locationObj.key == "address-delivery") {
                 
                       setValue(t("AddressesDelivery"))
                       let selectedAddress=res.data.data.data.find(ele=>ele.latitude==locationObj.lat&&ele.longitude==locationObj.lng)
           
                       setLocationString(selectedAddress.name+"-"+selectedAddress.address)
                   }
               }
                let temp = res.data.data.data
                if (temp.length && temp.filter(i => i.defaultAddress == true).length > 0) {
                    setAddressDelivery(temp.filter(i => i.defaultAddress == true)[0].id)
                }
            }).catch(err => console.log("err"))
        }
        if (getCookieValue("location")) {
            let locationObj = getCookieValue("location")
            setCurrentLocation(locationObj)

            if (locationObj.key == "my-location") {
                setValue(t("myLocation"))
                setLocationString(t("myLocation"))
            }
            if (locationObj.key == "map-location") {
                setValue(t("setTheAddressManually"))
                setLocationString(t("TheAddressSelectedManually"))
            }
         

        }
    }, [])
    const [value, setValue] = React.useState(t("myLocation"));
    const [locationString, setLocationString] = React.useState('')
    const handleChange = (event) => {
        setValue(event.target.value);
    };
    const [openMap, setOpenMap] = React.useState(false)
    const handleSubmit = () => {
        setOpen(false)
        if (value == t("myLocation")) {
            setLocationString(t("myLocation"))
           
            navigator.geolocation.getCurrentPosition(success, errors, options)
        }
        if (value == t("setTheAddressManually")) {
            setLocationString(t("TheAddressSelectedManually"))
            setOpenMap(true)
        }
        if (value == t("AddressesDelivery")) {

            let getSelectedAddress = OrderAddress.find(ele => ele.id == addressDelivery)
            setLocationString(getSelectedAddress.name + "-" + getSelectedAddress.address)

            if (getSelectedAddress.latitude && getSelectedAddress.longitude) {
             props.callBackData({lat: getSelectedAddress.latitude, lng: getSelectedAddress.longitude })
                setCookiesValues("location", JSON.stringify({ key: "address-delivery", lat: getSelectedAddress.latitude, lng: getSelectedAddress.longitude }))
            }
        }

    }
    const [addressDelivery, setAddressDelivery] = React.useState()
    const handleChangeAddressDelivery = (e) => {
        setAddressDelivery(e.target.value)
    }
    return (
        <div className='flex justify-center mb-4 mt-2 flex-col items-center '>
          
            <div className='flex w-full lg:w-3/6 lg:px-3 justify-center'>
                <div className='flex shadow-md rounded border w-full justify-between py-2 px-2' ><div className='flex items-center justify-center justify-items-center ' >

                    <AddLocationIcon />
                    {t("nearstTo")} ({locationString})</div>
                    <Stack direction="row" spacing={2}>

                        <div>
                            <Button
                                ref={anchorRef}
                                id="composition-button"
                                aria-controls={open ? 'composition-menu' : undefined}
                                aria-expanded={open ? 'true' : undefined}
                                aria-haspopup="true"
                                onClick={handleToggle}
                                color="secondary"
                            >
                                {t("Change")}
                            </Button>

                        </div>
                    </Stack>
                </div>
            </div>
            <BootstrapDialog open={open}
                anchorEl={anchorRef.current}
                maxWidth={"xs"}
                PaperProps={{
                    sx: { overflow: "visible", position: "relative", direction: "rtl", width: "100%" },

                }}
            >
                <DialogTitle>
                    <div className='tex-center font-bold'>{t("nearstTo")} </div>
                    
                    
                </DialogTitle>

                <FormControl>
                    <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue="female"
                        name="radio-buttons-group"
                        value={value}
                        onChange={handleChange}
                    >
                        <FormControlLabel  value={t("myLocation")} control={<Radio />} label={t("myLocation")} sx={{ marginLeft: 0,width:"100%" }} />
                        <FormControlLabel value={t("setTheAddressManually")} control={<Radio />} label={t("setTheAddressManually")} sx={{ marginLeft: 0,width:"100%" }} />

                        {isLoggedIn && OrderAddress.length > 0 ? <div className='flex mt-2 w-full'>
                            <div className='w-5/12 flex items-cenetr'><FormControlLabel value={t("AddressesDelivery")} control={<Radio />} label={t("AddressesDelivery")} sx={{ marginLeft: 0 }} /></div>

                            <div className='w-7/12 '> <CustomeFormControl size={"small"} sx={{ direction: router.locale == "ar" ? "rtl" : "ltr", alignItems: "right", textalign: "end" }}
                         
                            >
                                <InputLabel> {t("TheAddress")}</InputLabel>
                                <Customeselect
                                    labelId="Address"
                                    id="Address"
                                    name="Address"

                                    value={addressDelivery}
                                   
                                    onChange={(e) => {
                                        handleChangeAddressDelivery(e)
                                    }}
                                    sx={{
                                        width: "61%",
                                        margin: "auto",
                                        display: "flex",
                                        alignItems: " center",
                                        boxShadow: " 0 0 4px #bcbcbc",
                                        direction: router.locale == "ar" ? "rtl" : "ltr",
                                        width: "100%",
                                        borderRadius: 0,
                                    }}
                                >

                                    {OrderAddress.filter(ele => vocabTerms.statusIds.includes(ele.statusId)).map(item => (
                                        <MenuItem style={{ direction: router.locale == "ar" ? "rtl" : "ltr", alignItems: "right" }} value={item.id} >
                                            {(item.name + "-" + item.address)}
                                        </MenuItem>
                                    ))}
                                </Customeselect>
                            </CustomeFormControl>
                            </div>
                        </div> : ""}

                    </RadioGroup>
                </FormControl>

                <DialogActions>
                    <div className='flex justify-center w-3/5 m-auto '>
                    <Customebtn
                    color="secondary"
                        variant={"contained"}

                        onClick={() => {
                            handleSubmit()
                        }}
                    >
                        {t("btnOk")}

                    </Customebtn>
                    <Customebtn
                     variant={"contained"}
                        onClick={() => setOpen(false)}

                    >
                        {t("btnCancel")}


                    </Customebtn>
                    </div>
                </DialogActions>

            </BootstrapDialog>
            {/* {console.log("currentLocationxxx---->",currentLocation)}
            {!currentLocation?"get your location":""} */}
            {openMap?<Map open={openMap} callbackLocation={(data) => {
           
            if(data){
                setCookiesValues("location", JSON.stringify({ key: "map-location", lat: data.lat, lng: data.lng }))
                setCurrentLocation(data)
                setOpenMap(false)
                props.callBackData({lat: data.lat, lng: data.lng})
            }
              
                  
                  }} currentLocate={{lat:currentLocation&&currentLocation.lat,lng:currentLocation&&(currentLocation.lng?currentLocation.lng:currentLocation.lng)}} />:""}
        </div>
    )
}
